import { LocalizationForm } from '../web-components/localization-form';